<template>
  <div>
    <v-layout row wrap mx-3>

      <v-flex style="background-color:#292929; color: #ddd;" class="mb-5 row  px-3 py-2 elevation-0 xs12">
        <span class="font-weight-bold left subheading">Timeline  </span>
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn v-if="!show_form" fab dark flat small icon class="right mr-2 mt-4" @click="show_form=true">
          <v-icon small dark>add</v-icon>
        </v-btn> -->
        
      </v-flex>
      <v-flex>
        <v-timeline dense>
            <v-timeline-item
              v-for="n in this.advanced_years"
              :key="n"
              color="black"
              fill-dot
              icon="dot"
              small
            >
              <v-card class="elevation-0">
                <v-card-title class="headline">{{a}}</v-card-title>
                <v-card-text>
                  <v-flex v-for="e in exhibitions.filter(e => { return e.duration_start_year == n })" :key="e.id">
                    <v-card class="elevation-0" color="grey lighten-3">
                      <v-card-title class="ml-0 pl-2"><h4 class="ml-0 pl-0">Exhibition - {{e.show_type == 0 ? "Solo show" : "Group show" }}: {{ e.title }}</h4></v-card-title>
                      <v-divider></v-divider>
                      <v-list two-line>
                        <v-list-tile>
                          <v-list-tile-content>
                            {{ e.institution }}, {{ e.city }}, {{ e.country }} <br>
                            {{full_date(e)}} 
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-flex>

                 </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-flex>
    </v-layout>

  </div>
</template>

<script>
  export default {
    props: ['artwork'],
    data: () => ({
      view: 'advanced',
      show_form: false,
      show: true,
      dialog: false
      // exhibitions: this.exhibitions2
    }),
    // created () {
    //   this.reset_view()
    // },
    methods: {
      deleteExhibition (e) {
        // var index = exhibition_artworks.indexOf(e);
        // console.log('index = ' + index)
        // exhibition_artworks.splice(index,1)
        this.$store.dispatch('deleteExhibition',e)
        this.dialog = false
      },
      // reset_view () {
      //   var ee = this.store_e
      //   this.exhibitions = this.exhibitions2
      //   // console.log('reset_view')
      //   // console.log(this.exhibitions2)
      // }
      start_date (e) {
        var out = e.duration_start_year
        var options = { day: 'numeric', month: 'long', year: 'numeric'};
        if (e.duration_start_month) {
          out = out + '-' + e.duration_start_month.toString().padStart(2, "0")
        }
        if (e.duration_start_day) {
          out = out + '-' + e.duration_start_day.toString().padStart(2, "0")
        }
        out = new Date(out).toLocaleDateString("en-US", options)

        return out
      },
      end_date (e) {
        var out = e.duration_end_year
        var options = { day: 'numeric', month: 'long', year: 'numeric'};

        if (e.duration_end_month) {
          out = out + '-' + e.duration_end_month.toString().padStart(2, "0")
          // out = e.duration_end_month.toLocaleDateString("en-US", options)
        }
        if (e.duration_end_day) {
          out = out + '-' + e.duration_end_day.toString().padStart(2, "0")
        }
        out = new Date(out).toLocaleDateString("en-US", options)
        return out
      },
      full_date (e){
        var out = this.start_date(e)
        if (this.end_date(e)) {
          out = out + ' - ' + this.end_date(e)
        }
        return out
      }
    },
    computed: {
      advanced_years () {
        return this.exhibitions.map(a => a = a.duration_start_year).sort(function(a, b) {
          return a - b;
        }).reverse().filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })},
      store_e () {
        // console.log('store_e')
        return this.$store.state.exhibitions
      },
      exhibitions () {
        // console.log('exa')
        return this.store_e.filter(t => {
          return t.artworks.map(a => a = a.artwork_id).includes(this.artwork.id)
      }).sort(function(a, b) {
        return a.duration_start - b.duration_start;
      })
    }
  }  
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artworks/Timeline.vue